  <span *ngFor="let tag of tags; let i = index; let last=last">
    <a *ngIf="link" [routerLink]="['/ors', activity, 'search']" [queryParams]="{where: stringify({$text: {$search: tag}})}">{{ tag }}</a>
    <span *ngIf="!link">{{ tag }}</span>
    <span *ngIf="!last">{{ seperator }}</span>
  </span>
